import { render, staticRenderFns } from "./resiliencyBoard.vue?vue&type=template&id=09a66b50&scoped=true&"
import script from "./resiliencyBoard.vue?vue&type=script&lang=js&"
export * from "./resiliencyBoard.vue?vue&type=script&lang=js&"
import style0 from "./resiliencyBoard.vue?vue&type=style&index=0&id=09a66b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a66b50",
  null
  
)

export default component.exports